import React from "react";
import ReactDOM from "react-dom";
import { Modal, Button, Form, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import config from "../../common/config";
import ChannelIcon from "../channel-defs/ChannelIcon.react";
import {defineMessages, IntlProvider} from 'react-intl';
import {getLocale} from '../../browser/locales';
import {getMessages} from '../../browser/getMessages';

const {intl} = new IntlProvider({locale: getLocale(), messages: getMessages()}, {}).getChildContext();

const messages = defineMessages({
	title: {id: 'inquiryModal.steps', defaultMessage: 'Following steps'},
    mainTextWithDativeryStep1: {id: 'inquiryModal.mainTextWithDativeryStep1', defaultMessage: 'After filling out and sending the following form, we will receive your non-binding inquiry and contacts.'},
    mainTextWithDativeryStep2: {id: 'inquiryModal.mainTextWithDativeryStep2', defaultMessage: 'Within a few working days, a Dativer consultant will contact you to discuss your ideas and requirements via video call or phone call.'},
    mainTextWithDativeryStep3: {id: 'inquiryModal.mainTextWithDativeryStep3', defaultMessage: 'You will receive a price offer including a timetable for implementation.'},
    mainTextWithDativeryStep4: {id: 'inquiryModal.mainTextWithDativeryStep4', defaultMessage: 'After agreeing the offer and obtaining access data, the consultant will install and set up the integration.'},
    mainTextWithDativeryStep5: {id: 'inquiryModal.mainTextWithDativeryStep5', defaultMessage: 'You try the integration and provide comments.'},
    mainTextWithDativeryStep6: {id: 'inquiryModal.mainTextWithDativeryStep6', defaultMessage: 'After processing the comments, the consultant will provide a running integration for acceptance.'},
    mainTextWithDativeryStep7: {id: 'inquiryModal.mainTextWithDativeryStep7', defaultMessage: 'After acceptance, an invoice is issued and monthly billing is started.'},
    mainTextAloneStep1: {id: 'inquiryModal.mainTextAloneStep1', defaultMessage: 'You press the "Install integration" button and start the wizard.'},
    mainTextAloneStep2: {id: 'inquiryModal.mainTextAloneStep2', defaultMessage: 'Connect Shoptet by filling in the e-shop address and access data.'},
    mainTextAloneStep3: {id: 'inquiryModal.mainTextAloneStep3', defaultMessage: 'Connect ABRA Flexi by filling in the accounting address and access data.'},
    mainTextAloneStep4: {id: 'inquiryModal.mainTextAloneStep4', defaultMessage: 'Set the integration behavior according to your needs.'},
    mainTextAloneStep5: {id: 'inquiryModal.mainTextAloneStep5', defaultMessage: 'You start the transfer of invoices and check the created invoices in ABRA Flexi.'},
    mainTextAloneStep6: {id: 'inquiryModal.mainTextAloneStep6', defaultMessage: 'The integration will start automatically according to the settings.'},
    mainTextAloneStep7: {id: 'inquiryModal.mainTextAloneStep7', defaultMessage: 'After 14 days, we will check the progress of the integration and start the monthly invoicing.'},
    mainTextNeedHelp: {id: 'inquiryModal.mainTextNeedHelp', defaultMessage: 'You can contact us at +420 377 477 415 or fill out the following form:'},
    name: {id: 'inquiryModal.name', defaultMessage: 'Name'},
    company: {id: 'inquiryModal.company', defaultMessage: 'Company'},
    phone: {id: 'inquiryModal.phone', defaultMessage: 'Phone'},
    email: {id: 'inquiryModal.email', defaultMessage: 'Email'},
    note: {id: 'inquiryModal.note', defaultMessage: 'Note'},
    send: {id: 'inquiryModal.send', defaultMessage: 'Send'},
    close: {id: 'inquiryModal.close', defaultMessage: 'Close'},
    install: {id: 'inquiryModal.install', defaultMessage: 'Install integration'},
    followSteps: {id: 'inquiryModal.followSteps', defaultMessage: 'Follow the steps below'},
});

let modalInstance = null; // Singleton pattern to ensure only one instance

class InquiryModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            name: "",
            companyName: "",
            phone: "",
            email: "",
            note: "",
            erp: props.erp,
            appName: props.appName,
            scenarioUrl: props.scenarioUrl,
        };

        modalInstance = this; // Ensuring a single instance
    }

    static show(props = {}) {
        if (modalInstance) {
            modalInstance.setState({ ...props, showModal: true });
        } else {
            const div = document.createElement("div");
            document.body.appendChild(div);

            ReactDOM.render(<InquiryModal />, div);
            modalInstance.setState({ ...props, showModal: true });
        }
    }

    close = () => {
        this.setState({ showModal: false });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    getLastPathSegment() {
        const path = window.location.pathname;
        const segments = path.split("/");
        return segments[segments.length - 1];
    }

    handleMailto = (event) => {
        event.preventDefault(); // Prevent the default anchor behavior

        const appName = this.getLastPathSegment();
        const { companyName, phone, email, note, typeOfInstall, scenarioUrl, scenarioName } = this.state;
        const recipientEmail = config.SALES_EMAIL;
        const subject = encodeURIComponent(`Poptávka z doplňku => ${appName}, od společnosti => ${companyName}`);
        const body = encodeURIComponent(`Integrace: ${scenarioName}\nZpůsob instalace: ${typeOfInstall}\nTel: ${phone}\nEmail: ${email}\nPoznámka: ${note}`);
        const mailtoURL = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;

        // Redirect to the mailto URL
        window.location.href = mailtoURL;
    };

    render() {
        const modalStyle = {
            // display: 'block', // Use 'block' to fill the screen
            // position: 'fixed',
            // zIndex: 1050,
            // top: '50%',
            // left: '50%',
            // transform: 'translate(-50%, -50%)',

            overflowY: "auto", // Allows for scrolling
            // Hide scrollbar for Webkit browsers
            "::-webkit-scrollbar": {
                display: "none",
            },
            // Hide scrollbar for Firefox
            "scrollbar-width": "none",
            // Optionally, hide scrollbar for IE and Edge
            "-ms-overflow-style": "none",
        };

        let texts = {
            "with-dativery": (
                <div>
                    <p><b>{intl.formatMessage(messages.followSteps)}:</b></p>
                    <ol>
                        <li>{intl.formatMessage(messages.mainTextWithDativeryStep1)}</li>
                        <li>{intl.formatMessage(messages.mainTextWithDativeryStep2)}</li>
                        <li>{intl.formatMessage(messages.mainTextWithDativeryStep3)}</li>
                        <li>{intl.formatMessage(messages.mainTextWithDativeryStep4)}</li>
                        <li>{intl.formatMessage(messages.mainTextWithDativeryStep5)}</li>
                        <li>{intl.formatMessage(messages.mainTextWithDativeryStep6)}</li>
                        <li>{intl.formatMessage(messages.mainTextWithDativeryStep7)}</li>
                    </ol>
                </div>
            ),
            alone: (
                <div>
                    <p><b>{intl.formatMessage(messages.followSteps)}:</b></p>
                    <ol>
                        <li>{intl.formatMessage(messages.mainTextAloneStep1)}</li>
                        <li>{intl.formatMessage(messages.mainTextAloneStep2, {erp: this.state.erp, appName: this.state.appName})}</li>
                        <li>{intl.formatMessage(messages.mainTextAloneStep3, {erp: this.state.erp, appName: this.state.appName})}</li>
                        <li>{intl.formatMessage(messages.mainTextAloneStep4)}</li>
                        <li>{intl.formatMessage(messages.mainTextAloneStep5, {erp: this.state.erp, appName: this.state.appName})}</li>
                        <li>{intl.formatMessage(messages.mainTextAloneStep6, {erp: this.state.erp, appName: this.state.appName})}</li>
                        <li>{intl.formatMessage(messages.mainTextAloneStep7, {erp: this.state.erp, appName: this.state.appName})}</li>
                    </ol>
                </div>
            ),
            "need-help": <p><b>{intl.formatMessage(messages.mainTextNeedHelp)}</b></p>,
        };

        return (
            <Modal onHide={this.close} show={this.state.showModal} style={modalStyle}>
                <Modal.Header style={{justifyContent: "center", alignItems:"center", display: "flex", backgroundColor: "#1B2021", borderRadius: "4px 4px 0 0"}}>
                <ChannelIcon
                    channelDef={{
                        icon: "dativery",
                        name: config.PRODUCT_NAME,
                    }}
                    key={1}
                    noDimensions
                    size={24}
                />
                </Modal.Header>
                <Modal.Body>
                    <div style={{ padding: "2rem" }}>
                        {texts[this.state.showType]}
                        <Form onSubmit={this.handleSubmit}>
                            {this.state.showType !== "alone" && (
                                <div style={{ marginTop: "4rem" }}>
                                    <FormGroup>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <ControlLabel style={{ width: "150px" }}>{intl.formatMessage(messages.name)}:</ControlLabel>
                                            <FormControl name="name" onChange={this.handleChange} required type="text" value={this.state.name} />
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <ControlLabel style={{ width: "150px" }}>{intl.formatMessage(messages.company)}:</ControlLabel>
                                            <FormControl name="company" onChange={this.handleChange} required type="text" value={this.state.companyName} />
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <ControlLabel style={{ width: "150px" }}>{intl.formatMessage(messages.phone)}:</ControlLabel>
                                            <FormControl name="phone" onChange={this.handleChange} required type="tel" value={this.state.phone} />
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <ControlLabel style={{ width: "150px" }}>{intl.formatMessage(messages.email)}:</ControlLabel>
                                            <FormControl name="email" onChange={this.handleChange} required type="email" value={this.state.email} />
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <ControlLabel style={{ width: "150px" }}>{intl.formatMessage(messages.note)}:</ControlLabel>
                                            <FormControl componentClass="textarea" name="note" onChange={this.handleChange} />
                                        </div>
                                    </FormGroup>
                                </div>
                            )}
                            <div style={{ display: "flex", justifyContent: "end", alignItems: "center", gap: "1rem", marginTop: "2rem" }}>
                                <Button bsStyle="default" onClick={this.close}>
                                    {intl.formatMessage(messages.close)}
                                </Button>
                                {this.state.showType === "alone" ? (
                                    <a className="btn btn-primary" href={this.state.scenarioUrl}>
                                        {intl.formatMessage(messages.install)}
                                    </a>
                                ) : (
                                    <button className="btn btn-primary" onClick={this.handleMailto}>
                                        {intl.formatMessage(messages.send)}
                                    </button>
                                )}
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export function displayInquiry() {
    returnPromise = InquiryModal.show(message);
    return returnPromise;
}

export default InquiryModal;
